import { createListenerMiddleware, type ListenerEffectAPI } from "@reduxjs/toolkit";
import type { AppDispatch, RootState } from "@/redux/store";
import {
  handleTrustPilotPersistentCart,
  TRUST_PILOT_PERSISTENT_CART_ACTIONS,
} from "@/redux/listener/funnels/trustPilotFunnelListener";

const listenerMiddleware = createListenerMiddleware();

TRUST_PILOT_PERSISTENT_CART_ACTIONS.forEach((action) => {
  listenerMiddleware.startListening({
    actionCreator: action,
    effect: (_action, listenerApi) => {
      handleTrustPilotPersistentCart(
        listenerApi as ListenerEffectAPI<RootState, AppDispatch>,
      );
    },
  });
});

export default listenerMiddleware;
